import styled from 'styled-components'
import { Button } from 'reactstrap'

export const MergeSiteLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  & .form-group {
    margin-right: 50px
  }
`

export const MergeSiteLayoutSection = styled.div`
  display: flex;
  flex-direction: column;
`
export const MergeSiteInputSection = styled.div`
  display: flex;
  flex-direction: row;
`

export const MergeSiteColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`
export const Divider = styled.hr`
  width: 100%;
`

export const MergeSiteButton = styled(Button)`
  margin: 5px;
`
export const MergeSiteColumnTitle = styled.div`
  font-size: 1rem;
  font-weight: bold;
  text-decoration: underline;
`
